module.exports = __webpack_public_path__ + "static/media/one.75e00025.jpg";